import { STORAGE_KEYS } from '@/constants'

const AUTH_TOKEN_KEY = STORAGE_KEYS.AUTH_TOKEN
const CHAIRPERSON_AUTH_TOKEN_KEY = STORAGE_KEYS.CHAIRPERSON_AUTH_TOKEN

export const extractAuthToken = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const urlToken = urlParams.get(AUTH_TOKEN_KEY)
  const urlTokenExpiry = urlParams.get(STORAGE_KEYS.AUTH_TOKEN_EXPIRY)
  return { token: urlToken, tokenExpiry: urlTokenExpiry }
}

export const extractChairpersonAuthToken = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const urlToken = urlParams.get(CHAIRPERSON_AUTH_TOKEN_KEY)
  const urlTokenExpiry = urlParams.get(
    STORAGE_KEYS.CHAIRPERSON_AUTH_TOKEN_EXPIRY
  )
  return { token: urlToken, tokenExpiry: urlTokenExpiry }
}

export const cleanUrlParams = () => {
  try {
    const url = new URL(window.location.href)
    let changed = false

    // Clean donor auth params
    if (url.searchParams.has(AUTH_TOKEN_KEY)) {
      url.searchParams.delete(AUTH_TOKEN_KEY)
      changed = true
    }
    if (url.searchParams.has(STORAGE_KEYS.AUTH_TOKEN_EXPIRY)) {
      url.searchParams.delete(STORAGE_KEYS.AUTH_TOKEN_EXPIRY)
      changed = true
    }

    // Clean chairperson auth params
    if (url.searchParams.has(CHAIRPERSON_AUTH_TOKEN_KEY)) {
      url.searchParams.delete(CHAIRPERSON_AUTH_TOKEN_KEY)
      changed = true
    }
    if (url.searchParams.has(STORAGE_KEYS.CHAIRPERSON_AUTH_TOKEN_EXPIRY)) {
      url.searchParams.delete(STORAGE_KEYS.CHAIRPERSON_AUTH_TOKEN_EXPIRY)
      changed = true
    }

    if (changed) {
      const clean = url.pathname + (url.search ? url.search : '') + url.hash
      window.history.replaceState(null, '', clean)
    }
  } catch (_) {
    // no-op
  }
}

export const getAuthToken = () => {
  return localStorage.getItem(AUTH_TOKEN_KEY)
}

export const setAuthToken = token => {
  localStorage.setItem(AUTH_TOKEN_KEY, token)
}

export const removeAuthToken = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY)
}

export const getTokenExpiry = () => {
  return localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN_EXPIRY)
}

export const isTokenExpired = () => {
  const expiryString = getTokenExpiry()
  if (!expiryString) return true

  const expiryTime = new Date(expiryString).getTime()
  const currentTime = new Date().getTime()

  return currentTime >= expiryTime
}

export const shouldRefreshToken = () => {
  const expiryString = getTokenExpiry()
  if (!expiryString) return false

  const expiryTime = new Date(expiryString).getTime()
  const currentTime = new Date().getTime()
  const twoMinutesInMs = 2 * 60 * 1000 // 2 minutes in milliseconds

  const timeUntilExpiry = expiryTime - currentTime
  return timeUntilExpiry > 0 && timeUntilExpiry <= twoMinutesInMs
}

export const getTimeUntilExpiry = () => {
  const expiryString = getTokenExpiry()
  if (!expiryString) return -1

  const expiryTime = new Date(expiryString).getTime()
  const currentTime = new Date().getTime()

  return expiryTime - currentTime
}

export const isTokenValid = () => {
  const token = getAuthToken()
  if (!token) return false

  return !isTokenExpired()
}
